import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommReefer extends Layout {
    dataheaderMobileCommReefer: DataHeader;
    panelMobileCommReefer: Panel;
    sourceReefer: DataSource;
    textboxCurrentFuelLevel: Textbox;
    textboxCurrentFuelLevelDate: Textbox;
    textboxId: Textbox;
    textboxInServiceDate: Textbox;
    textboxMake: Textbox;
    textboxModel: Textbox;
    textboxOutOfServiceDate: Textbox;
    textboxPercentageFuelDate: Textbox;
    textboxPercentageFuelLeft: Textbox;
    textboxSerialNumber: Textbox;
    textboxServiceStatus: Textbox;
    textboxTotalEngineHours: Textbox;
    textboxTotalEngineHoursDate: Textbox;
    textboxTotalFuel: Textbox;
    textboxTrailer: Textbox;
}
